export const SERIES = "VMKB_078";
export const DIAMETER = "VBGR_078";
export const MATERIAL = "VWST_078";
export const COATING = "VBSCH_078";
export const TOLERANCE = "VTOL_078";

export const SHAFT_MACHINING_LEFT = "VBEAL_078";
export const SHAFT_MACHINING_MIDDLE = "VBEAM_078";
export const SHAFT_MACHINING_RIGHT = "VBEAR_078";

export const SHAFT_LENGTH_METRIC = "VLKUWUM_078";
export const SHAFT_LENGTH_METRIC_MIN = "VLKUWUT01_078";
export const SHAFT_LENGTH_METRIC_MAX = "VLNUM_02_078";

export const SHAFT_LENGTH_INCH = "VLZKUWU_078";
export const SHAFT_LENGTH_INCH_MIN = "VZLKUWUT01_078";
export const SHAFT_LENGTH_INCH_MAX = "VLNU_078";

export const SHAFT_NUMBER_OF_PARTS = "VM990H_078";

export const shaftTolerance = {
  value: "VLMAX_01A_078",
  minmax: {
    ls: "VTOLZ_LS_078",
    ln: "VTOLZ_LN_078",
  },
  maxDecimal: 4,
};

export const SHAFT_TOLERANCE_MINMAX = "VLZMAX_03T_078";

export const UNIT = "″";

export const chamfer = {
  left: {
    angle: "VL010_01_078",
    width: {
      sf: "VL010_02_078",
      nf: "VL010_02H_Z_078",
      minmax: "VL010_02SF_078",
    },
  },
  right: {
    angle: "VR010_01_078",
    width: {
      sf: "VR010_02_078", // Editable
      nf: "VR010_02H_Z_078", // Not editable, reference only
      minmax: "VR010_02SF_078",
    },
  },
};

export const radialThread = {
  pdt: "VM980_01_078",
  threadSpacing: {
    inch: "VMZ980_050_078",
    metric: "VM980_050_078",
  },
  aL: {
    inch: {
      value: "VMZ980_02_1_078",
      min: "VMZ980_02_1T01_078",
      max: "VMZ980_02_1T02_078",
    },
    metric: {
      value: "VM980_02_1_078",
      min: "VM980_02_1T01_078",
      max: "VM980_02_1T02_078",
    },
  },
  aR: {
    inch: {
      value: "VMZ980_02_3_078",
      min: "VMZ980_02_3T01_078",
      max: "VMZ980_02_3T02_078",
    },
    metric: {
      value: "VM980_02_3_078",
      min: "VM980_02_3T01_078",
      max: "VM980_02_3T02_078",
    },
  },
  aLaREnabler: "VM980_02_078",
  threadHoleAmount: "VM980_070_078",
  threadDepth: "VM980T_01_078",
};
